export default "__VITE_ASSET__D4wMOPbI__"